export enum Colors {
  BLACK = "#000",
  GREY = "#D9D9D9",
  WHITE = "#FFF",
}
